<template>
  <div class="d-flex d-sm-none justify-content-center pb-3">
                <button
                @click="confirmObject"
                  type="button"
                  id="new-btn"
                  class="rounded-pill p-1 ps-2 pe-3 btn btn-outline-secondary text-nowrap btn-sm"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 86 86"
                    width="16"
                    height="16"
                  >
                    <polygon
                      points="86 34.76 51.24 34.76 51.24 0 34.76 0 34.76 34.76 0 34.76 0 51.24 34.76 51.24 34.76 86 51.24 86 51.24 51.24 86 51.24 86 34.76"
                      fill="#004d97"
                      stroke-width="0"
                    ></polygon></svg >新建
                </button>
              </div>
</template>

<script>
export default {
  name: "btn-new-h5",
  data() {
    return {};
  },
  methods: {
    confirmObject() {
      var con;
      con = confirm("注意：如果您没有导出最新修改的图像，它们将丢失。\n是否要创建新架构？"); //在页面上弹出对话框
      if (con == true){
		// 刷新页面
		window.location.reload();

	  }else{

	  }
      
    },
  },
};
</script>

<style scoped="scoped" lang="less"></style>
